import styled from "styled-components";
import { useState, useEffect } from "react";
import FormCheckBox from "../../../../../components/FormControls/FormCheckBox";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormNumberInput from "../../../../../components/FormControls/FormNumberInput";
import FormPasswordInput from "../../../../../components/FormControls/FormPasswordInput";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../api/request";
import { updateObject } from "../../../../../utils/object";
import { NotificationManager } from 'react-notifications';

const StyledEmailSystemSettings = styled.div`
    margin-left: 30px;
`;

const SettingsBoard = styled.div`
    background-color: white;
    width: 755px;
    box-sizing: border-box;
    min-height: 157px;
    padding: 30px;
    margin-bottom: 30px;
    color: ${(props) => props.theme.color.gray};
`;

const Title = styled.span`
    display: block;
    color: ${(props) => props.theme.color.primaryblue};
    font-size: 14px;
    font-weight: 600;
    padding-bottom: 5px;
`;

function EmailSystemSettings(props) {

    const [isSaving, setIsSaving] = useState(false);
    const [isSendingEmail, setIsSendingEmail] = useState(false);
    const [isSmtpPasswordChanged, setIsSmtpPasswordChanged] = useState(false);
    const [smtpHostName, setSmtpHostName] = useState('');
    const [smtpPort, setSmtpPort] = useState(25);
    const [smtpUserName, setSmtpUserName] = useState('');
    const [smtpPassword, setSmtpPassword] = useState('');
    const [smtpEmailFrom, setSmtpEmailFrom] = useState('');
    const [isEnableSSL, setIsEnableSSL] = useState(false);
    const [isUsingDotNetDLL, setIsUsingDotNetDLL] = useState(false);
    const [sendTestEmailTo, setSendTestEmailTo] = useState('');

    const onSaveChanges = async () => {
        setIsSaving(true);
        let saveData = {
            SMTPHostName: smtpHostName,
            SMTPPort: smtpPort,
            SMTPUserName: smtpUserName,
            SMTPEmailFrom: smtpEmailFrom,
            EnableSSL: isEnableSSL,
            UseNETEmail: isUsingDotNetDLL,
        }
        if (isSmtpPasswordChanged) {
            saveData.SMTPPassword = smtpPassword;
        }

        const resp = (await request('database', 'saveSettings', [saveData]));
        if (resp.ok) {
            updateObject(props.settings, saveData);
            props.setSettings(props.settings);
            NotificationManager.success('Email settings saved');
        } else
        {
            console.log(resp.data);
            NotificationManager.error(resp.data);
        }
        setIsSaving(false);
    };

    const handleChangeSMTPPassword = (password) => {
        setSmtpPassword(password);
        setIsSmtpPasswordChanged(true);
    }
    
    const onSendTestEmail = async () => {
        if (sendTestEmailTo !== '') {
            setIsSendingEmail(true);
            let emailData = {};
            emailData.emailTo = sendTestEmailTo;
            emailData.subject = 'Email test from CAMRA Online Branch Accounting System';
            emailData.text = 'This is a test email from CAMRA Online Branch Accounting System.';

            const resp = (await request('database', 'sendEmail', [emailData]));
            if (resp.ok) {
                NotificationManager.success('Email sent');
            } else
            {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsSendingEmail(false);
        }
    };

    useEffect(() => {
        props.setPageTitle('Email settings');
        setSmtpHostName(props.settings.SMTPHostName || '');
        setSmtpPort(props.settings.SMTPPort || 25);
        setSmtpUserName(props.settings.SMTPUserName || '');
        setSmtpPassword("*************");
        setSmtpEmailFrom(props.settings.SMTPEmailFrom || '');
        setIsEnableSSL(props.settings.EnableSSL || '');
        setIsUsingDotNetDLL(props.settings.UseNETEmail || '');
    }, []);
    
    return (
        <StyledEmailSystemSettings>
            <SettingsBoard>
                <Title>SMTP settings</Title>
                <FormStringInput label='SMTP hostname' placeholder='smtpemailclient.com' value={smtpHostName} onChange={(val) => setSmtpHostName(val)} inputStyle={{width:290}}></FormStringInput>
                <FormNumberInput label='SMTP port' value={smtpPort} onChange={(val) => setSmtpPort(val)} min='1' inputStyle={{width:85}}></FormNumberInput>
                <FormStringInput label='SMTP username' placeholder='officeemail@smtpclient.com' value={smtpUserName} onChange={(val) => setSmtpUserName(val)} inputStyle={{width:290}}></FormStringInput>
                <FormPasswordInput label='SMTP password' placeholder='password' value={smtpPassword} onChange={(val) => handleChangeSMTPPassword(val)} inputStyle={{width:290}}></FormPasswordInput>
                <FormStringInput label='SMTP email from' placeholder='officeemail@smtpclient.com' value={smtpEmailFrom} onChange={(val) => setSmtpEmailFrom(val)} inputStyle={{width:290}}></FormStringInput>
                <div style={{display: 'flex', width: 278}}>
                    <FormCheckBox label='Enable SSL' checked={isEnableSSL} onCheck={(val) => setIsEnableSSL(val)}></FormCheckBox>
                    <FormCheckBox label='Send using .NET DLL' checked={isUsingDotNetDLL} onCheck={(val) => setIsUsingDotNetDLL(val)} style={{marginLeft: 'auto'}}></FormCheckBox>
                </div>
            </SettingsBoard>
            <SettingsBoard>
                <Title>Email testing</Title>
                <div style={{display: 'flex'}}>
                    <FormStringInput label='Send test email to:' placeholder='smtpemailclient.com' value={sendTestEmailTo} onChange={(val) => setSendTestEmailTo(val)} inputStyle={{width:290}}></FormStringInput>
                    <div style={{paddingLeft: 30, marginTop: 'auto'}}><SecondaryButton caption='Send test email' isLoading={isSendingEmail} onClick={() => onSendTestEmail()}></SecondaryButton></div>
                </div>
            </SettingsBoard>
            <div style={{float: 'right'}}><PrimaryButton caption='Save changes' isLoading={isSaving} onClick={() => onSaveChanges()}></PrimaryButton></div>
        </StyledEmailSystemSettings>
    )
}

export default EmailSystemSettings;